export enum NotificationTypes {
  orderCompleted = 'order_completed',
  downtime = 'downtime',
  emergency = 'emergency',
  vinUndeliverable = 'vin_undeliverable',
  vanUnassigned = 'van_unassigned',
  porterAssignedToVan = 'porter_assigned_to_van',
  porterRemovedFromVan = 'porter_removed_from_van',
  jobAssignedToVan = 'job_assigned_to_van',
  vanAssignedToOrder = 'van_assigned_to_order',
  transportCompleted = 'transport_completed',
  vinStatusChanged = 'vin_status_changed',
}

export type NotificationTypesValues = `${NotificationTypes}`;

export const NotificationsTypesLabels: Record<NotificationTypesValues, string> = {
  [NotificationTypes.orderCompleted]: 'Order Completed',
  [NotificationTypes.downtime]: 'Downtime',
  [NotificationTypes.emergency]: 'Emergency',
  [NotificationTypes.vinUndeliverable]: 'VIN Undeliverable',
  [NotificationTypes.vanUnassigned]: 'Van Unassigned',
  [NotificationTypes.porterAssignedToVan]: 'Porter Assigned to Van',
  [NotificationTypes.porterRemovedFromVan]: 'Porter Removed from Van',
  [NotificationTypes.jobAssignedToVan]: 'Job Assigned to Van',
  [NotificationTypes.vanAssignedToOrder]: 'Van Assigned to Order',
  [NotificationTypes.transportCompleted]: 'Transport Completed',
  [NotificationTypes.vinStatusChanged]: 'VIN Status Changed',
};

export interface Notification {
  id: number,
  createdAt: string,
  readAt: string,
  type: NotificationTypes,
  title: string,
  description: string,
  context: string,
}

export interface NotificationStats {
  total: number,
  read: number,
  unread: number,
}
